import React from 'react';
import GroupComponent from './GroupComponent';

const SecondaryGroup = (props) => {
  return (
    <GroupComponent 
      {...props} 
      groupType="secondary" 
      actionSummary={props.actionSummary} 
      groupID={props.groupID} // Pass groupID as a prop
      role="secondary" // Pass role as a prop
    />
  );
};

export default SecondaryGroup;